var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-10 text-center"},[(_vm.icon)?_c('v-img',{staticClass:"mx-auto mb-2",attrs:{"src":_vm.src,"max-width":"120px","height":"100","contain":""}}):_vm._e(),_c('h3',[_vm._v(_vm._s(_vm.description))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }